import React from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { Done } from '@material-ui/icons';

const Container = styled.div`
  padding: 2.125rem;
  border: 4px solid ${({ theme }) => theme.palette.blue.light};
  border-radius: 0.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const OuterContainer = styled.div`
  margin-top: 1.875rem;
  padding: 1.875rem 0;
  border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
`;

const DiscardButton = styled.button`
  font-size: 1rem;
  font-family: ${({ theme }) => theme.typography.headerFontFamily};
  text-transform: uppercase;
  font-weight: 600;
  padding: 0.6875rem 1.875rem;
  color: ${({ theme }) => theme.palette.blue.light};
  background: transparent;
  border: none;
`;

const ShortlistSection = ({ onDeal, onDiscard, isDeal }) => (
  <OuterContainer>
    <Container>
      {isDeal ? (
        <Button
          variant="contained"
          className="t-weight-b u-mrg-5 button--green"
        >
          <Done /> Deal
        </Button>
      ) : (
        <Button
          color="secondary"
          variant="outlined"
          className="t-primary-16 u-mrg-5"
          onClick={onDeal}
        >
          Deal
        </Button>
      )}
      <DiscardButton onClick={onDiscard}>Discard</DiscardButton>
    </Container>
  </OuterContainer>
);

export default ShortlistSection;
